export default __webpack_public_path__ + "static/media/jornal.f7b80f0a.png";